import React from 'react'

function DiscountsManagements() {
  return (
    <div>DiscountsManagements</div>
  )
}

export default DiscountsManagements